import { ThemeOptions } from '@mui/material';

import * as MuiPopover from './MuiPopover';

export type {} from './MuiPopover';

export const utils: ThemeOptions['components'] = {
  ...MuiPopover
};
